var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-alert", {
    attrs: {
      message: _vm.$t("保险公司审核已通过，应保险公司要求，您需将以下资料邮寄至保险公司复核。"),
      banner: ""
    }
  }), _c("top-title", {
    staticClass: "marginT20",
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("收件信息")))])]), _vm.infoData.consigneeInfo ? _c("div", [_c("div", {
    staticClass: "nameCont"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("姓名")) + ":")]), _vm._v(_vm._s(_vm.infoData.consigneeInfo.name) + " "), _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("手机号")) + ":")]), _vm._v(_vm._s(_vm.infoData.consigneeInfo.mobile) + " ")])]), _c("div", {
    staticClass: "nameCont"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("详细地址")) + ":")]), _vm._v(_vm._s(_vm.infoData.consigneeInfo.address) + " ")])]) : _vm._e(), _c("top-title", {
    staticClass: "marginT20",
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("资料清单")))])]), _c("a-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      bordered: "",
      columns: _vm.documentColumns,
      "data-source": _vm.infoData.list,
      align: "center",
      pagination: false,
      rowKey: "documentId",
      scroll: {
        y: 300
      }
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "remark",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text) + " ")];
      }
    }])
  }), _c("top-title", {
    staticClass: "marginT20",
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("寄件信息")))])]), _c("a-form-model", {
    ref: "from",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      model: _vm.mailingInfo,
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("物流公司"),
      prop: "logisticsCompany"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("物流公司")
    },
    model: {
      value: _vm.mailingInfo.logisticsCompany,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "logisticsCompany", $$v);
      },
      expression: "mailingInfo.logisticsCompany"
    }
  }, _vm._l(_vm.logisticsSelectList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item,
        label: item
      }
    }, [_vm._v(_vm._s(item) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("运单号"),
      prop: "shipmentNum"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("运单号")
    },
    model: {
      value: _vm.mailingInfo.shipmentNum,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "shipmentNum", $$v);
      },
      expression: "mailingInfo.shipmentNum"
    }
  })], 1)], 1), _c("top-title", {
    staticClass: "marginT20",
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("资料回寄地址")))]), _c("div", {
    attrs: {
      slot: "btn"
    },
    slot: "btn"
  }, [_c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.addConsigneeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增") + _vm.$t("收件信息")))])], 1)]), _c("a-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      bordered: "",
      columns: _vm.consigneeListColumns,
      "data-source": _vm.consigneeList,
      align: "center",
      pagination: false,
      rowKey: "consigneeId",
      scroll: {
        y: 400
      },
      rowSelection: {
        selectedRowKeys: _vm.selectedRowKeysArray,
        onChange: _vm.onSelectChange,
        type: "radio"
      }
    },
    scopedSlots: _vm._u([{
      key: "address",
      fn: function (text, record) {
        return [_c("span", {
          staticClass: "marginR15"
        }, [_vm._v(_vm._s(text))]), record.isDefault == 1 ? _c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("默认地址")))]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [record.isDefault != 1 ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "link",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDefault(record.consigneeId);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("设置默认")))]) : _vm._e(), _c("a-button", {
          attrs: {
            type: "linkDanger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDel(record.consigneeId);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }])
  }, _vm._l(_vm.documentListColumns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.consigneeShow ? _c("consignee-model", {
    ref: "consigneeForm",
    on: {
      ok: _vm.consigneeFun,
      cancel: function ($event) {
        _vm.consigneeShow = false;
      }
    }
  }) : _vm._e(), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };